export default 
   
   ` 
   @font-face
{
    font-family: "aachenn";
    src: url("../fontlar/aachenn.ttf") format("truetype");
}

@font-face
{
    font-family: "Ab -thar";
    src: url("../fontlar/Ab -thar.ttf") format("truetype");
}

@font-face
{
    font-family: "AdventPro-Medium";
    src: url("../fontlar/AdventPro-Medium.ttf") format("truetype");
}

@font-face
{
    font-family: "adwa-assalaf B";
    src: url("../fontlar/adwa-assalaf B.ttf") format("truetype");
}

@font-face
{
    font-family: "adwa-assalaf";
    src: url("../fontlar/adwa-assalaf.ttf") format("truetype");
}

@font-face
{
    font-family: "AkayaKanadaka-Regular";
    src: url("../fontlar/AkayaKanadaka-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGrotesk-ExtraBold";
    src: url("../fontlar/AkzidenzGrotesk-ExtraBold.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGrotesk-ExtraBoldCond";
    src: url("../fontlar/AkzidenzGrotesk-ExtraBoldCond.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGrotesk-UltraBoldCond";
    src: url("../fontlar/AkzidenzGrotesk-UltraBoldCond.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGroteskPro-Bold";
    src: url("../fontlar/AkzidenzGroteskPro-Bold.ttf") format("truetype");
}
@font-face
{
    font-family: "AkzidenzGroteskPro-Light";
    src: url("../fontlar/AkzidenzGroteskPro-Light.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGroteskPro-LightCn";
    src: url("../fontlar/AkzidenzGroteskPro-LightCn.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGroteskPro-LightIt";
    src: url("../fontlar/AkzidenzGroteskPro-LightIt.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGroteskPro-Md";
    src: url("../fontlar/AkzidenzGroteskPro-Md.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGroteskPro-MdIt";
    src: url("../fontlar/AkzidenzGroteskPro-MdIt.ttf") format("truetype");
}

@font-face
{
    font-family: "AkzidenzGroteskPro-Regular";
    src: url("../fontlar/AkzidenzGroteskPro-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Al Tarikh";
    src: url("../fontlar/Al Tarikh.ttc") format("truetype");
}

@font-face
{
    font-family: "AlHurraTxtBold";
    src: url("../fontlar/AlHurraTxtBold.ttf") format("truetype");
}

@font-face
{
    font-family: "AlHurraTxtreg";
    src: url("../fontlar/AlHurraTxtreg.ttf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab100";
    src: url("../fontlar/AlianzaSlab100.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab200";
    src: url("../fontlar/AlianzaSlab200.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab300";
    src: url("../fontlar/AlianzaSlab300.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab400";
    src: url("../fontlar/AlianzaSlab400.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab500";
    src: url("../fontlar/AlianzaSlab500.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab600";
    src: url("../fontlar/AlianzaSlab600.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab700";
    src: url("../fontlar/AlianzaSlab700.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab800";
    src: url("../fontlar/AlianzaSlab800.otf") format("truetype");
}

@font-face
{
    font-family: "AlianzaSlab900";
    src: url("../fontlar/AlianzaSlab900.otf") format("truetype");
}

@font-face
{
    font-family: "alletha-Regular";
    src: url("../fontlar/alletha-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "Allura-Regular";
    src: url("../fontlar/Allura-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Altrincham W01 Oblique";
    src: url("../fontlar/Altrincham W01 Oblique.ttf") format("truetype");
}

@font-face
{
    font-family: "Altrincham-Bol";
    src: url("../fontlar/Altrincham-Bol.otf") format("truetype");
}

@font-face
{
    font-family: "Altrincham-Reg";
    src: url("../fontlar/Altrincham-Reg.otf") format("truetype");
}

@font-face
{
    font-family: "AlwaysForever-Bold";
    src: url("../fontlar/AlwaysForever-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "AmericanTypewriter";
    src: url("../fontlar/AmericanTypewriter.ttc") format("truetype");
}

@font-face
{
    font-family: "AnnieUseYourTelescope";
    src: url("../fontlar/AnnieUseYourTelescope.ttf") format("truetype");
}

@font-face
{
    font-family: "Arabic Symbols 01";
    src: url("../fontlar/Arabic Symbols 01.otf") format("truetype");
}

@font-face
{
    font-family: "Arial Black";
    src: url("../fontlar/Arial Black.ttf") format("truetype");
}

@font-face
{
    font-family: "arial";
    src: url("../fontlar/arial.ttf") format("truetype");
}

@font-face
{
    font-family: "AThuluth";
    src: url("../fontlar/AThuluth.ttf") format("truetype");
}

@font-face
{
    font-family: "Audiowide-Regular";
    src: url("../fontlar/Audiowide-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Authenia";
    src: url("../fontlar/Authenia.otf") format("truetype");
}

@font-face
{
    font-family: "Avenir Next";
    src: url("../fontlar/Avenir Next.ttc") format("truetype");
}

@font-face
{
    font-family: "Axiforma-Black";
    src: url("../fontlar/Axiforma-Black.otf") format("truetype");
}

@font-face
{
    font-family: "Axiforma-Bold";
    src: url("../fontlar/Axiforma-Bold.otf") format("truetype");
}

@font-face
{
    font-family: "Axiforma-Medium";
    src: url("../fontlar/Axiforma-Medium.otf") format("truetype");
}

@font-face
{
    font-family: "Axiforma-Regular";
    src: url("../fontlar/Axiforma-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "Axiforma-SemiBold";
    src: url("../fontlar/Axiforma-SemiBold.otf") format("truetype");
}

@font-face
{
    font-family: "Axiforma-Thin";
    src: url("../fontlar/Axiforma-Thin.otf") format("truetype");
}

@font-face
{
    font-family: "Barlow-Bold";
    src: url("../fontlar/Barlow-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "Barlow-Italic";
    src: url("../fontlar/Barlow-Italic.ttf") format("truetype");
}

@font-face
{
    font-family: "Barlow-Regular";
    src: url("../fontlar/Barlow-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Baro-Plain";
    src: url("../fontlar/Baro-Plain.otf") format("truetype");
}

@font-face
{
    font-family: "BauerB";
    src: url("../fontlar/BauerB.ttf") format("truetype");
}

@font-face
{
    font-family: "Bellevue";
    src: url("../fontlar/Bellevue.ttf") format("truetype");
}

@font-face
{
    font-family: "berlingi";
    src: url("../fontlar/berlingi.ttf") format("truetype");
}

@font-face
{
    font-family: "Bickham2";
    src: url("../fontlar/Bickham2.otf") format("truetype");
}

@font-face
{
    font-family: "billy-bold";
    src: url("../fontlar/billy-bold.otf") format("truetype");
}

@font-face
{
    font-family: "billy-semibold";
    src: url("../fontlar/billy-semibold.otf") format("truetype");
}

@font-face
{
    font-family: "Blur";
    src: url("../fontlar/Blur.ttf") format("truetype");
}

@font-face
{
    font-family: "BrandonGrotesque-Bold";
    src: url("../fontlar/BrandonGrotesque-Bold.otf") format("truetype");
}

@font-face
{
    font-family: "Butler_Ultra_Light_Stencil";
    src: url("../fontlar/Butler_Ultra_Light_Stencil.otf") format("truetype");
}

@font-face
{
    font-family: "CambayDevanagari";
    src: url("../fontlar/CambayDevanagari.ttc") format("truetype");
}

@font-face
{
    font-family: "Cera Pro Black";
    src: url("../fontlar/Cera Pro Black.otf") format("truetype");
}

@font-face
{
    font-family: "Cera Pro Bold Italic";
    src: url("../fontlar/Cera Pro Bold Italic.otf") format("truetype");
}

@font-face
{
    font-family: "Cera Pro Bold";
    src: url("../fontlar/Cera Pro Bold.otf") format("truetype");
}

@font-face
{
    font-family: "Cera Pro Light Italic";
    src: url("../fontlar/Cera Pro Light Italic.otf") format("truetype");
}

@font-face
{
    font-family: "Cera Pro Light";
    src: url("../fontlar/Cera Pro Light.otf") format("truetype");
}

@font-face
{
    font-family: "Cera Pro Medium";
    src: url("../fontlar/Cera Pro Medium.otf") format("truetype");
}

@font-face
{
    font-family: "Cera Pro Regular Italic";
    src: url("../fontlar/Cera Pro Regular Italic.otf") format("truetype");
}

@font-face
{
    font-family: "CeraPro-Black";
    src: url("../fontlar/CeraPro-Black.otf") format("truetype");
}

@font-face
{
    font-family: "CeraPro-BlackItalic";
    src: url("../fontlar/CeraPro-BlackItalic.otf") format("truetype");
}

@font-face
{
    font-family: "CeraPro-Bold";
    src: url("../fontlar/CeraPro-Bold.otf") format("truetype");
}

@font-face
{
    font-family: "CeraPro-Italic";
    src: url("../fontlar/CeraPro-Italic.otf") format("truetype");
}

@font-face
{
    font-family: "CeraPro-Light";
    src: url("../fontlar/CeraPro-Light.otf") format("truetype");
}

@font-face
{
    font-family: "CeraPro-MediumItalic";
    src: url("../fontlar/CeraPro-MediumItalic.otf") format("truetype");
}

@font-face
{
    font-family: "CeraPro-Regular";
    src: url("../fontlar/CeraPro-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "CgTower-CondensedRegular";
    src: url("../fontlar/CgTower-CondensedRegular.ttf") format("truetype");
}

@font-face
{
    font-family: "ChronicleDispCond-Roman";
    src: url("../fontlar/ChronicleDispCond-Roman.otf") format("truetype");
}

@font-face
{
    font-family: "COCOGOOSELETTERPRESS";
    src: url("../fontlar/COCOGOOSELETTERPRESS.ttf") format("truetype");
}

@font-face
{
    font-family: "Colby-CdBlk";
    src: url("../fontlar/Colby-CdBlk.otf") format("truetype");
}

@font-face
{
    font-family: "Colby-CdMed";
    src: url("../fontlar/Colby-CdMed.otf") format("truetype");
}

@font-face
{
    font-family: "Colby-CpBlk";
    src: url("../fontlar/Colby-CpBlk.otf") format("truetype");
}

@font-face
{
    font-family: "Colby-CpReg";
    src: url("../fontlar/Colby-CpReg.otf") format("truetype");
}

@font-face
{
    font-family: "Colby-StBld";
    src: url("../fontlar/Colby-StBld.otf") format("truetype");
}

@font-face
{
    font-family: "Colby-StBlk";
    src: url("../fontlar/Colby-StBlk.otf") format("truetype");
}

@font-face
{
    font-family: "Colby-StMed";
    src: url("../fontlar/Colby-StMed.otf") format("truetype");
}

@font-face
{
    font-family: "Colby-StReg";
    src: url("../fontlar/Colby-StReg.otf") format("truetype");
}

@font-face
{
    font-family: "CoolveticaCondensedRg-Regular";
    src: url("../fontlar/CoolveticaCondensedRg-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "CoolveticaRg-Regular";
    src: url("../fontlar/CoolveticaRg-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Damascus";
    src: url("../fontlar/Damascus.ttc") format("truetype");
}

@font-face
{
    font-family: "DecoTypeNaskh";
    src: url("../fontlar/DecoTypeNaskh.ttc") format("truetype");
}

@font-face
{
    font-family: "Didot";
    src: url("../fontlar/Didot.ttc") format("truetype");
}

@font-face
{
    font-family: "DIN-Bold";
    src: url("../fontlar/DIN-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "DIN-LightItalic";
    src: url("../fontlar/DIN-LightItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "DIN-MediumItalic";
    src: url("../fontlar/DIN-MediumItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "DIN-Medium_0";
    src: url("../fontlar/DIN-Medium_0.ttf") format("truetype");
}

@font-face
{
    font-family: "DINT";
    src: url("../fontlar/DINT.otf") format("truetype");
}

@font-face
{
    font-family: "DINTBold";
    src: url("../fontlar/DINTBold.otf") format("truetype");
}

@font-face
{
    font-family: "DINTMedium";
    src: url("../fontlar/DINTMedium.otf") format("truetype");
}

@font-face
{
    font-family: "Exo-Bold";
    src: url("../fontlar/Exo-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "GeezaPro";
    src: url("../fontlar/GeezaPro.ttc") format("truetype");
}

@font-face
{
    font-family: "Georgia Italic";
    src: url("../fontlar/Georgia Italic.ttf") format("truetype");
}

@font-face
{
    font-family: "Georgia";
    src: url("../fontlar/Georgia.ttf") format("truetype");
}

@font-face
{
    font-family: "GloriaHallelujah";
    src: url("../fontlar/GloriaHallelujah.ttf") format("truetype");
}

@font-face
{
    font-family: "GreatVibes-Regular";
    src: url("../fontlar/GreatVibes-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeue";
    src: url("../fontlar/HelveticaNeue.ttc") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Bd";
    src: url("../fontlar/HelveticaNeueLTPro-Bd.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BdCn";
    src: url("../fontlar/HelveticaNeueLTPro-BdCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BdCnO";
    src: url("../fontlar/HelveticaNeueLTPro-BdCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BdEx";
    src: url("../fontlar/HelveticaNeueLTPro-BdEx.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BdExO";
    src: url("../fontlar/HelveticaNeueLTPro-BdExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BdIt";
    src: url("../fontlar/HelveticaNeueLTPro-BdIt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BdOu";
    src: url("../fontlar/HelveticaNeueLTPro-BdOu.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Blk";
    src: url("../fontlar/HelveticaNeueLTPro-Blk.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BlkCn";
    src: url("../fontlar/HelveticaNeueLTPro-BlkCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BlkCnO";
    src: url("../fontlar/HelveticaNeueLTPro-BlkCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BlkEx";
    src: url("../fontlar/HelveticaNeueLTPro-BlkEx.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BlkExO";
    src: url("../fontlar/HelveticaNeueLTPro-BlkExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-BlkIt";
    src: url("../fontlar/HelveticaNeueLTPro-BlkIt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Cn";
    src: url("../fontlar/HelveticaNeueLTPro-Cn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-CnO";
    src: url("../fontlar/HelveticaNeueLTPro-CnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Ex";
    src: url("../fontlar/HelveticaNeueLTPro-Ex.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-ExO";
    src: url("../fontlar/HelveticaNeueLTPro-ExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Hv";
    src: url("../fontlar/HelveticaNeueLTPro-Hv.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-HvCn";
    src: url("../fontlar/HelveticaNeueLTPro-HvCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-HvCnO";
    src: url("../fontlar/HelveticaNeueLTPro-HvCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-HvEx";
    src: url("../fontlar/HelveticaNeueLTPro-HvEx.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-HvExO";
    src: url("../fontlar/HelveticaNeueLTPro-HvExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-HvIt";
    src: url("../fontlar/HelveticaNeueLTPro-HvIt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-It";
    src: url("../fontlar/HelveticaNeueLTPro-It.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Lt";
    src: url("../fontlar/HelveticaNeueLTPro-Lt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-LtCn";
    src: url("../fontlar/HelveticaNeueLTPro-LtCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-LtCnO";
    src: url("../fontlar/HelveticaNeueLTPro-LtCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-LtEx";
    src: url("../fontlar/HelveticaNeueLTPro-LtEx.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-LtExO";
    src: url("../fontlar/HelveticaNeueLTPro-LtExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-LtIt";
    src: url("../fontlar/HelveticaNeueLTPro-LtIt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Md";
    src: url("../fontlar/HelveticaNeueLTPro-Md.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-MdCn";
    src: url("../fontlar/HelveticaNeueLTPro-MdCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-MdCnO";
    src: url("../fontlar/HelveticaNeueLTPro-MdCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-MdEx";
    src: url("../fontlar/HelveticaNeueLTPro-MdEx.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-MdExO";
    src: url("../fontlar/HelveticaNeueLTPro-MdExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-MdIt";
    src: url("../fontlar/HelveticaNeueLTPro-MdIt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Roman";
    src: url("../fontlar/HelveticaNeueLTPro-Roman.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-Th";
    src: url("../fontlar/HelveticaNeueLTPro-Th.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-ThCn";
    src: url("../fontlar/HelveticaNeueLTPro-ThCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-ThCnO";
    src: url("../fontlar/HelveticaNeueLTPro-ThCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-ThEx";
    src: url("../fontlar/HelveticaNeueLTPro-ThEx.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-ThExO";
    src: url("../fontlar/HelveticaNeueLTPro-ThExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-ThIt";
    src: url("../fontlar/HelveticaNeueLTPro-ThIt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-UltLt";
    src: url("../fontlar/HelveticaNeueLTPro-UltLt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-UltLtCn";
    src: url("../fontlar/HelveticaNeueLTPro-UltLtCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-UltLtCnO";
    src: url("../fontlar/HelveticaNeueLTPro-UltLtCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-UltLtEx";
    src: url("../fontlar/HelveticaNeueLTPro-UltLtEx.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-UltLtExO";
    src: url("../fontlar/HelveticaNeueLTPro-UltLtExO.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-UltLtIt";
    src: url("../fontlar/HelveticaNeueLTPro-UltLtIt.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-XBlkCn";
    src: url("../fontlar/HelveticaNeueLTPro-XBlkCn.otf") format("truetype");
}

@font-face
{
    font-family: "HelveticaNeueLTPro-XBlkCnO";
    src: url("../fontlar/HelveticaNeueLTPro-XBlkCnO.otf") format("truetype");
}

@font-face
{
    font-family: "HeroePro";
    src: url("../fontlar/HeroePro.otf") format("truetype");
}

@font-face
{
    font-family: "Heroliga Bold";
    src: url("../fontlar/Heroliga Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "HeroligaBold";
    src: url("../fontlar/HeroligaBold.ttf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans1-Black";
    src: url("../fontlar/HurmeGeometricSans1-Black.otf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans2-Black";
    src: url("../fontlar/HurmeGeometricSans2-Black.otf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans2-Bold";
    src: url("../fontlar/HurmeGeometricSans2-Bold.otf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans2-Light";
    src: url("../fontlar/HurmeGeometricSans2-Light.otf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans2-Regular";
    src: url("../fontlar/HurmeGeometricSans2-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans3-Black";
    src: url("../fontlar/HurmeGeometricSans3-Black.otf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans3-Light";
    src: url("../fontlar/HurmeGeometricSans3-Light.otf") format("truetype");
}

@font-face
{
    font-family: "HurmeGeometricSans3-Regular";
    src: url("../fontlar/HurmeGeometricSans3-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "IntegralCF-BoldOblique";
    src: url("../fontlar/IntegralCF-BoldOblique.otf") format("truetype");
}

@font-face
{
    font-family: "IntroCondBlackFree";
    src: url("../fontlar/IntroCondBlackFree.otf") format("truetype");
}

@font-face
{
    font-family: "JitzuSwash-Medium";
    src: url("../fontlar/JitzuSwash-Medium.otf") format("truetype");
}

@font-face
{
    font-family: "KGHAPPY";
    src: url("../fontlar/KGHAPPY.ttf") format("truetype");
}

@font-face
{
    font-family: "Kondolar-Black";
    src: url("../fontlar/Kondolar-Black.otf") format("truetype");
}

@font-face
{
    font-family: "Kondolar-Bold";
    src: url("../fontlar/Kondolar-Bold.otf") format("truetype");
}

@font-face
{
    font-family: "Kondolar-Italic";
    src: url("../fontlar/Kondolar-Italic.otf") format("truetype");
}

@font-face
{
    font-family: "Kondolar-Regular";
    src: url("../fontlar/Kondolar-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "Laffayette_Comic_Pro";
    src: url("../fontlar/Laffayette_Comic_Pro.ttf") format("truetype");
}

@font-face
{
    font-family: "LustScript";
    src: url("../fontlar/LustScript.otf") format("truetype");
}

@font-face
{
    font-family: "Mahdi-Regular";
    src: url("../fontlar/Mahdi-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "majalla";
    src: url("../fontlar/majalla.ttf") format("truetype");
}

@font-face
{
    font-family: "majallab";
    src: url("../fontlar/majallab.ttf") format("truetype");
}

@font-face
{
    font-family: "MarckScript-Regular";
    src: url("../fontlar/MarckScript-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "MarkerFelt";
    src: url("../fontlar/MarkerFelt.ttc") format("truetype");
}

@font-face
{
    font-family: "Mexcellent-Regular";
    src: url("../fontlar/Mexcellent-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "MinionPro-Regular";
    src: url("../fontlar/MinionPro-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "Mohave-Light";
    src: url("../fontlar/Mohave-Light.otf") format("truetype");
}

@font-face
{
    font-family: "Monotype Cor";
    src: url("../fontlar/Monotype Corsiva") format("truetype");
}

@font-face
{
    font-family: "Montserrat-Black";
    src: url("../fontlar/Montserrat-Black.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-Bold";
    src: url("../fontlar/Montserrat-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-ExtraBold";
    src: url("../fontlar/Montserrat-ExtraBold.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-Italic";
    src: url("../fontlar/Montserrat-Italic.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-Light";
    src: url("../fontlar/Montserrat-Light.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-LightItalic";
    src: url("../fontlar/Montserrat-LightItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-Medium";
    src: url("../fontlar/Montserrat-Medium.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-Regular";
    src: url("../fontlar/Montserrat-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Montserrat-SemiBold";
    src: url("../fontlar/Montserrat-SemiBold.ttf") format("truetype");
}

@font-face
{
    font-family: "Mulish-Bold";
    src: url("../fontlar/Mulish-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "Mulish-ExtraBold";
    src: url("../fontlar/Mulish-ExtraBold.ttf") format("truetype");
}

@font-face
{
    font-family: "Mulish-Italic-VariableFont_wght";
    src: url("../fontlar/Mulish-Italic-VariableFont_wght.ttf") format("truetype");
}

@font-face
{
    font-family: "Mulish-VariableFont_wght";
    src: url("../fontlar/Mulish-VariableFont_wght.ttf") format("truetype");
}

@font-face
{
    font-family: "NarzissProCy-Regular-Drops";
    src: url("../fontlar/NarzissProCy-Regular-Drops.otf") format("truetype");
}

@font-face
{
    font-family: "NarzissProCyrillic";
    src: url("../fontlar/NarzissProCyrillic.ttf") format("truetype");
}

@font-face
{
    font-family: "NarzissProCyrillicDrops-Bold";
    src: url("../fontlar/NarzissProCyrillicDrops-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "NarzissProCyrillicDrops-Medium";
    src: url("../fontlar/NarzissProCyrillicDrops-Medium.otf") format("truetype");
}

@font-face
{
    font-family: "NarzissProCyrillicDrops";
    src: url("../fontlar/NarzissProCyrillicDrops.ttf") format("truetype");
}

@font-face
{
    font-family: "Neo Sans Std Medium TR";
    src: url("../fontlar/Neo Sans Std Medium TR.otf") format("truetype");
}

@font-face
{
    font-family: "Noteworthy";
    src: url("../fontlar/Noteworthy.ttc") format("truetype");
}

@font-face
{
    font-family: "OnlyYouSexyBold";
    src: url("../fontlar/OnlyYouSexyBold.otf") format("truetype");
}

@font-face
{
    font-family: "Othelie-LineItalic";
    src: url("../fontlar/Othelie-LineItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCompPro-Bold";
    src: url("../fontlar/PFDinTextCompPro-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCompPro-Regular";
    src: url("../fontlar/PFDinTextCompPro-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-Bold";
    src: url("../fontlar/PFDinTextCondPro-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-Light";
    src: url("../fontlar/PFDinTextCondPro-Light.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-LightItalic";
    src: url("../fontlar/PFDinTextCondPro-LightItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-Medium";
    src: url("../fontlar/PFDinTextCondPro-Medium.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-MediumItalic";
    src: url("../fontlar/PFDinTextCondPro-MediumItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-Regular";
    src: url("../fontlar/PFDinTextCondPro-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-Thin";
    src: url("../fontlar/PFDinTextCondPro-Thin.ttf") format("truetype");
}

@font-face
{
    font-family: "PFDinTextCondPro-ThinItalic";
    src: url("../fontlar/PFDinTextCondPro-ThinItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "Pistoletto Free 400";
    src: url("../fontlar/Pistoletto Free 400.otf") format("truetype");
}

@font-face
{
    font-family: "PlayfairDisplay-Bold";
    src: url("../fontlar/PlayfairDisplay-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "PlayfairDisplay-BoldItalic";
    src: url("../fontlar/PlayfairDisplay-BoldItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "PlayfairDisplay-Italic";
    src: url("../fontlar/PlayfairDisplay-Italic.ttf") format("truetype");
}

@font-face
{
    font-family: "PlayfairDisplay-MediumItalic";
    src: url("../fontlar/PlayfairDisplay-MediumItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "PlayfairDisplay-Regular";
    src: url("../fontlar/PlayfairDisplay-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "PlayfairDisplay-SemiBold";
    src: url("../fontlar/PlayfairDisplay-SemiBold.ttf") format("truetype");
}

@font-face
{
    font-family: "PlayfairDisplay-SemiBoldItalic";
    src: url("../fontlar/PlayfairDisplay-SemiBoldItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "Poppins-Black";
    src: url("../fontlar/Poppins-Black.ttf") format("truetype");
}

@font-face
{
    font-family: "Poppins-Bold";
    src: url("../fontlar/Poppins-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "Poppins-Regular";
    src: url("../fontlar/Poppins-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Raleway-Bold";
    src: url("../fontlar/Raleway-Bold.otf") format("truetype");
}

@font-face
{
    font-family: "Raleway-Bold";
    src: url("../fontlar/Raleway-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "Raleway-BoldItalic";
    src: url("../fontlar/Raleway-BoldItalic.ttf") format("truetype");
}

@font-face
{
    font-family: "Raleway-ExtraLight";
    src: url("../fontlar/Raleway-ExtraLight.otf") format("truetype");
}

@font-face
{
    font-family: "Raleway-Heavy";
    src: url("../fontlar/Raleway-Heavy.otf") format("truetype");
}

@font-face
{
    font-family: "Raleway-Italic";
    src: url("../fontlar/Raleway-Italic.ttf") format("truetype");
}

@font-face
{
    font-family: "Raleway-Medium";
    src: url("../fontlar/Raleway-Medium.otf") format("truetype");
}

@font-face
{
    font-family: "Raleway-Regular";
    src: url("../fontlar/Raleway-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "Raleway-Regular";
    src: url("../fontlar/Raleway-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Raneya";
    src: url("../fontlar/Raneya.ttf") format("truetype");
}

@font-face
{
    font-family: "RaptorV3Premium-Black";
    src: url("../fontlar/RaptorV3Premium-Black.otf") format("truetype");
}

@font-face
{
    font-family: "RaptorV3Premium-Regular";
    src: url("../fontlar/RaptorV3Premium-Regular.otf") format("truetype");
}

@font-face
{
    font-family: "Roboto-Bold";
    src: url("../fontlar/Roboto-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "Scheherazade-Bold";
    src: url("../fontlar/Scheherazade-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "Scheherazade-Regular";
    src: url("../fontlar/Scheherazade-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "ScheherazadeRegOT";
    src: url("../fontlar/ScheherazadeRegOT.ttf") format("truetype");
}

@font-face
{
    font-family: "SignPainter";
    src: url("../fontlar/SignPainter.ttc") format("truetype");
}

@font-face
{
    font-family: "SteelfishRg-Regular";
    src: url("../fontlar/SteelfishRg-Regular.ttf") format("truetype");
}

@font-face
{
    font-family: "Swis721BlkCnBT-Black";
    src: url("../fontlar/Swis721BlkCnBT-Black.ttf") format("truetype");
}

@font-face
{
    font-family: "Swis721BlkOulBT-Black";
    src: url("../fontlar/Swis721BlkOulBT-Black.ttf") format("truetype");
}

@font-face
{
    font-family: "SWISS721-Book-Cond";
    src: url("../fontlar/SWISS721-Book-Cond.ttf") format("truetype");
}

@font-face
{
    font-family: "SWISS721-Light";
    src: url("../fontlar/SWISS721-Light.ttf") format("truetype");
}

@font-face
{
    font-family: "SWZ721C";
    src: url("../fontlar/SWZ721C.TTF") format("truetype");
}

@font-face
{
    font-family: "Times New Roman Italic";
    src: url("../fontlar/Times New Roman Italic.ttf") format("truetype");
}

@font-face
{
    font-family: "Times New Roman";
    src: url("../fontlar/Times New Roman.ttf") format("truetype");
}

@font-face
{
    font-family: "Times";
    src: url("../fontlar/Times.ttc") format("truetype");
}

@font-face
{
    font-family: "URWLatinoTOT-Bol";
    src: url("../fontlar/URWLatinoTOT-Bol.otf") format("truetype");
}

@font-face
{
    font-family: "URWLatinoTOT-BolIta";
    src: url("../fontlar/URWLatinoTOT-BolIta.otf") format("truetype");
}

@font-face
{
    font-family: "URWLatinoTOT-Reg";
    src: url("../fontlar/URWLatinoTOT-Reg.otf") format("truetype");
}

@font-face
{
    font-family: "URWLatinoTOT-RegIta";
    src: url("../fontlar/URWLatinoTOT-RegIta.otf") format("truetype");
}

@font-face
{
    font-family: "verdanab";
    src: url("../fontlar/verdanab.ttf") format("truetype");
}

@font-face
{
    font-family: "YakoutLinotypeLight-Bold";
    src: url("../fontlar/YakoutLinotypeLight-Bold.ttf") format("truetype");
}

@font-face
{
    font-family: "YakoutLinotypeLight-Regular";
    src: url("../fontlar/YakoutLinotypeLight-Regular.ttf") format("truetype");
}
`
    

